/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CircleCheckSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CircleCheckSmall',
      'aria-hidden': true,
      focusable: false,
      width:  13 * scale,
      height: 13 * scale,
      viewBox: '0 0 13 13',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M6.5 1a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m-.458 8.06-2.8-2.8L4.3 5.197l1.74 1.74 2.87-2.863 1.06 1.06-3.928 3.928z"}))
}
